// Reports page entry point

import { initSwiperReportsWithResize } from './swiper-reports.js';

// ─── Swiper ───────────────────────────────────────────────────────────────────

initSwiperReportsWithResize();
